import CircleIcon from '@mui/icons-material/Circle';
import { SimplePaletteColorOptions, useTheme } from '@mui/material';

type UseRecentScanIndicatorReturn = {
  shortDescription?: string;
  longDescription?: string;
  color: SimplePaletteColorOptions;
  icon: typeof CircleIcon;
};
export const useRecentScanIndicator = (): UseRecentScanIndicatorReturn => {
  const theme = useTheme();
  return {
    shortDescription: 'Recent',
    longDescription: 'Scan recently completed',
    color: {
      main: theme.colors.common.bloomfieldGreen,
    },
    icon: CircleIcon,
  };
};
